import React, { useEffect, useState } from "react";
import { Container, Row, Col, Card, Accordion, Form } from "react-bootstrap";
import {
  FaEnvelope,
  FaFileAlt,
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaVideo,
  FaComments,
  FaCalendarCheck,
  FaFileInvoiceDollar,
} from "react-icons/fa";
import { Link } from "react-router-dom";
import { getLead } from "../../store/slices/leads";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";

export default function LeadDetails() {
  const [tab, setTab] = useState("overview");

  const dispatch = useDispatch();
  const { id } = useParams();

  const [leadData, setLeadData] = useState([]);

  useEffect(() => {
    const fetchLead = async () => {
      try {
        const res = await dispatch(getLead({ id })).unwrap();
        const leads = res?.leads[0] || [];

        console.log(res.leads);

        setLeadData(leads);
      } catch (error) {
        console.error(error);
      }
    };

    fetchLead();
  }, [dispatch, id]);

  // conversation inside of filter tab
  const [filterTab, setFilterTab] = useState("All");

  const [stage, setStage] = useState("Qualified");

  const [showLogActivity, setShowLogActivity] = useState(false);
  const [note, setNote] = useState("");

  const ovStatsData = [
    {
      title: "Total Quoted",
      value: "₹22,80,000",
      sub: "Across 3 proposals",
      color: "ov-orange",
    },
    {
      title: "Conversations",
      value: "6",
      sub: "3 email · 2 call · 1 note",
      color: "ov-blue",
    },
    {
      title: "Days in Pipeline",
      value: "55",
      sub: "Since Jan 14, 2026",
      color: "ov-purple",
    },
  ];

  const ovActivityData = [
    {
      icon: <FaEnvelope />,
      title: "Re: Revised Proposal – QT–2026–041",
      text: "Thanks for the updated quote. The pricing looks much better. Can we schedule a call this week to discuss the implementation...",
      time: "Today, 10:42 AM",
      type: "ov-email",
    },
    {
      icon: <FaPhoneAlt />,
      title: "Follow-up on Q2 Roadmap",
      text: "45-min call. Discussed Q2 feature needs — AI reporting module was flagged as a must-have. Arjun confirmed budget cleared...",
      time: "Mar 5, 3:15 PM",
      type: "ov-call",
    },
    {
      icon: <FaEnvelope />,
      title: "Revised Proposal – QT–2026–041 v2",
      text: "Hi Arjun, as discussed, I've attached our revised proposal with the adjusted licensing tiers and updated SLA terms...",
      time: "Feb 28, 11:00 AM",
      type: "ov-email",
    },
    {
      icon: <FaFileAlt />,
      title: "Internal Note",
      text: "Arjun mentioned their board is pushing for a SOC2-compliant vendor. We should highlight our certifications...",
      time: "Feb 26, 5:30 PM",
      type: "ov-note",
    },
  ];

  const qtData = [
    {
      id: "041",
      title: "Enterprise SaaS Platform – Annual",
      version: "v2",
      code: "QT–2026–041",
      items: "6 line items",
      sent: "Sent Feb 28, 2026",
      valid: "Valid till Mar 28, 2026",
      amount: "₹12,40,000",
      status: "Under Review",
      statusClass: "qt-under",
    },
    {
      id: "029",
      title: "Enterprise SaaS Platform – Starter",
      version: "v1",
      code: "QT–2026–029",
      items: "4 line items",
      sent: "Sent Feb 10, 2026",
      valid: "Valid till Mar 10, 2026",
      amount: "₹8,60,000",
      status: "Revised",
      statusClass: "qt-revised",
    },
    {
      id: "018",
      title: "Pilot – 3 Month Trial",
      version: "v1",
      code: "QT–2026–018",
      items: "2 line items",
      sent: "Sent Jan 22, 2026",
      valid: "Valid till Feb 22, 2026",
      amount: "₹1,80,000",
      status: "Declined",
      statusClass: "qt-declined",
    },
  ];

  const conversations = [
    {
      icon: <FaEnvelope />,
      title: "Re: Revised Proposal – QT–2026–041",
      user: "Arjun Mehta",
      time: "Today, 10:42 AM",
      preview: "Thanks for the updated quote. The pricing looks much better...",
      details:
        "Thanks for the updated quote. The pricing looks much better. Can we schedule a call this week to discuss the implementation timeline? We're aiming to go live before end of Q1.",
      tag: "Inbound",
      color: "blue",
    },
    {
      icon: <FaPhoneAlt />,
      title: "Follow-up on Q2 Roadmap",
      user: "Priya Sharma",
      time: "Mar 5, 3:15 PM",
      preview: "45-min call. Discussed Q2 feature needs...",
      details:
        "45-min call discussion. AI reporting module was flagged as a must-have. Arjun confirmed budget approval.",
      tag: "45 min",
      color: "green",
    },
    {
      icon: <FaEnvelope />,
      title: "Revised Proposal – QT–2026–041 v2",
      user: "Priya Sharma",
      time: "Feb 28, 11:00 AM",
      preview: "Hi Arjun, as discussed, I’ve attached our revised proposal...",
      details:
        "Hi Arjun, as discussed, I’ve attached our revised proposal with the adjusted licensing tiers and updated SLA terms.",
      tag: "2 attachments",
      color: "gray",
    },
    {
      icon: <FaFileAlt />,
      title: "Internal Note",
      user: "Priya Sharma",
      time: "Feb 26, 5:30 PM",
      preview: "Arjun mentioned their board is pushing for SOC2...",
      details:
        "Arjun mentioned their board is pushing for a SOC2-compliant vendor. We should highlight our certifications.",
      tag: "Internal",
      color: "yellow",
    },
    {
      icon: <FaVideo />,
      title: "Demo: Enterprise Dashboard",
      user: "Vikram Singh",
      time: "Feb 24, 2:00 PM",
      preview: "Walkthrough of the custom analytics suite...",
      details:
        "Conducted a 30-minute demo of the new dashboard. Vikram was specifically interested in the multi-tenant data isolation features.",
      tag: "Video",
      color: "blue",
    },
    {
      icon: <FaEnvelope />,
      title: "Contract Update: Clause 4.2",
      user: "Legal Team",
      time: "Feb 22, 9:15 AM",
      preview: "Requested changes to the liability section...",
      details:
        "The legal team has requested a modification to the liability caps. They want to ensure alignment with their current insurance policy before signing.",
      tag: "Urgent",
      color: "green",
    },
    {
      icon: <FaComments />,
      title: "Quick Slack Check-in",
      user: "Rohan Das",
      time: "Feb 20, 4:45 PM",
      preview: "Rohan asked about the API documentation link...",
      details:
        "Sent over the Swagger documentation for the integration endpoints. Rohan confirmed they will start testing the sandbox tomorrow.",
      tag: "Support",
      color: "yellow",
    },
    {
      icon: <FaCalendarCheck />,
      title: "Kickoff Meeting Scheduled",
      user: "Operations",
      time: "Feb 18, 10:00 AM",
      preview: "Confirmed for March 15th at 11 AM...",
      details:
        "The project kickoff is officially on the calendar. Invitations have been sent to all stakeholders including the engineering leads.",
      tag: "Event",
      color: "blue",
    },
    {
      icon: <FaEnvelope />,
      title: "Introduction: New Account Manager",
      user: "Sarah Jenkins",
      time: "Feb 15, 1:20 PM",
      preview: "Hello team, I’ll be taking over the account...",
      details:
        "Sarah introduced herself as the new primary point of contact for the upcoming fiscal year. Handover notes have been shared with Priya.",
      tag: "Intro",
      color: "green",
    },
    {
      icon: <FaFileInvoiceDollar />,
      title: "Invoice #INV-2026-08",
      user: "Finance Dept",
      time: "Feb 12, 11:30 AM",
      preview: "Deposit for Phase 1 has been processed...",
      details:
        "The 25% deposit for the implementation phase has been received. We are cleared to begin the technical discovery sessions.",
      tag: "Paid",
      color: "blue",
    },
  ];

  return (
    <>
      {/* Breadcrumb */}
      <div className="breadcrumb-bar mb-2">
        <div className="breadcrumb-left">
          <Link to="/hote/home" className="breadcrumb-link active">
            Home
          </Link>
          <span className="breadcrumb-separator"> | </span>
          <Link to="/hotel/lead" className="breadcrumb-link active">
            Packages
          </Link>
          <span className="breadcrumb-separator"> | </span>
          <span className="breadcrumb-link inactive">Lead Details</span>
        </div>
      </div>

      <Container fluid className="lead-container">
        <Row>
          {/* Profile card and contact card */}

          <Col lg={4} md={12}>
            <Card className="profile-card" style={{ border: "none" }}>
              <div className="avatar">{leadData?.name?.charAt(0)}</div>

              <h4 className="name">{leadData?.name}</h4>

              <p className="designation">{leadData?.email || "email"}</p>

              <div className="tags">
                <span>{leadData?.status}</span>
                <span>{leadData?.priority}</span>
                <span>{leadData?.currency}</span>
              </div>

              <hr />

              <div className="lead-score">
                <div className="score-circle">{leadData?.budget}</div>

                <div>
                  <p className="label">LEAD SCORE</p>
                  <p className="intent">{leadData?.source}</p>
                </div>
              </div>

              <hr />

              <div className="stage">
                <p className="profilelabel">STAGE</p>

                <div className="stage-buttons">
                  <button
                    onClick={() => setStage("Qualified")}
                    className={stage === "Qualified" ? "active" : "submit-btn"}
                  >
                    Qualified
                  </button>

                  <button
                    onClick={() => setStage("Proposal")}
                    className={stage === "Proposal" ? "active" : "submit-btn"}
                  >
                    Proposal
                  </button>

                  <button
                    onClick={() => setStage("Negotiation")}
                    className={
                      stage === "Negotiation" ? "active" : "submit-btn"
                    }
                  >
                    Negotiation
                  </button>

                  <button
                    onClick={() => setStage("Closed")}
                    className={stage === "Closed" ? "active" : "submit-btn"}
                  >
                    Closed
                  </button>
                </div>
              </div>

              <div className="details">
                <div>
                  <span>Deal Value</span>
                  <b className="price">₹{leadData?.budget}</b>
                </div>

                <div>
                  <span>Source</span>
                  <b>{leadData?.source}</b>
                </div>

                <div>
                  <span>Created</span>
                  <b>
                    {leadData?.createdAt
                      ? new Date(leadData.createdAt).toLocaleDateString()
                      : ""}
                  </b>
                </div>

                <div>
                  <span>Travel Date</span>
                  <b>
                    {leadData?.tentativeTravelDate
                      ? new Date(
                          leadData.tentativeTravelDate,
                        ).toLocaleDateString()
                      : ""}
                  </b>
                </div>
              </div>
            </Card>

            {/* contact card <----- */}

            <Card className="contact-card" style={{ border: "none" }}>
              <p className="label">CONTACT</p>

              <div className="contact-item">
                <FaEnvelope />
                {leadData?.email}
              </div>

              <div className="contact-item">
                <FaPhoneAlt />
                {leadData?.phone}
              </div>

              <div className="contact-item">
                <FaMapMarkerAlt />
                {leadData?.country}
              </div>

              <button className="submit-btn w-100">Log Activity</button>
            </Card>
          </Col>

          <Col lg={8} md={12}>
            <div className="top-tabs">
              <Row className="mb-3">
                <Col>
                  <div
                    className="my-2"
                    style={{
                      display: "flex",
                      background: "#f3f4f6",
                      padding: "6px",
                      borderRadius: "16px",
                      width: "100%",
                      maxWidth: "420px",
                    }}
                  >
                    <button
                      onClick={() => setTab("overview")}
                      style={{
                        flex: 1,
                        padding: "8px 12px",
                        border: "none",
                        borderRadius: "12px",
                        background:
                          tab === "overview" ? "#1E0959" : "transparent",
                        color: tab === "overview" ? "#fff" : "#374151",
                        fontWeight: 500,
                        fontSize: "14px",
                        transition: "0.2s",
                      }}
                    >
                      Overview
                    </button>

                    <button
                      onClick={() => setTab("quotations")}
                      style={{
                        flex: 1,
                        padding: "8px 12px",
                        border: "none",
                        borderRadius: "12px",
                        background:
                          tab === "quotations" ? "#1E0959" : "transparent",
                        color: tab === "quotations" ? "#fff" : "#374151",
                        fontWeight: 500,
                        fontSize: "14px",
                        transition: "0.2s",
                      }}
                    >
                      Quotations
                    </button>

                    <button
                      onClick={() => setTab("conversations")}
                      style={{
                        flex: 1,
                        padding: "8px 12px",
                        border: "none",
                        borderRadius: "12px",
                        background:
                          tab === "conversations" ? "#1E0959" : "transparent",
                        color: tab === "conversations" ? "#fff" : "#374151",
                        fontWeight: 500,
                        fontSize: "14px",
                        transition: "0.2s",
                      }}
                    >
                      Conversations
                    </button>
                  </div>
                </Col>
              </Row>
            </div>

            {tab === "overview" && (
              <>
                <Row className="ov-stats-row">
                  {ovStatsData.map((item, index) => (
                    <Col lg={4} md={6} key={index} className="my-2">
                      <div className="ov-stat-card">
                        <div className="ov-stat-title">{item.title}</div>

                        <div className={`ov-stat-value ${item.color}`}>
                          {item.value}
                        </div>

                        <div className="ov-stat-sub">{item.sub}</div>
                      </div>
                    </Col>
                  ))}
                </Row>

                <div className="ov-activity-card">
                  <div className="ov-activity-header">Recent Activity</div>

                  {ovActivityData.map((item, index) => (
                    <div className="ov-activity-row" key={index}>
                      <div className="ov-activity-icon-area">
                        <div className={`ov-icon-circle ${item.type}`}>
                          {item.icon}
                        </div>

                        {index !== ovActivityData.length - 1 && (
                          <div className="ov-vertical-line"></div>
                        )}
                      </div>

                      <div className="ov-activity-content">
                        <div className="ov-activity-title">{item.title}</div>

                        <div className="ov-activity-text">{item.text}</div>
                      </div>

                      <div className="ov-activity-time">{item.time}</div>
                    </div>
                  ))}
                </div>
              </>
            )}

            {tab === "quotations" && (
              <>
                <div className="qt-header">
                  <div className="qt-count">3 quotations sent</div>

                  <button
                    className="submit-btn p-1"
                    style={{ fontSize: "13px" }}
                  >
                    + Create Quotation
                  </button>
                </div>

                {qtData.map((item, index) => (
                  <div className="qt2-card" key={index}>
                    <div className="qt2-left">
                      <div className="qt2-id-box">
                        <span>QT</span>
                        <strong>{item.id}</strong>
                      </div>

                      <div className="qt2-info">
                        <div className="qt2-title-row">
                          <div className="qt2-title">{item.title}</div>

                          <span className="qt2-version">{item.version}</span>
                        </div>

                        <div className="qt2-meta">
                          {item.code} · {item.items} · {item.sent} ·{" "}
                          {item.valid}
                        </div>
                      </div>
                    </div>

                    <div className="qt2-right">
                      <div className="qt2-price">{item.amount}</div>

                      <div className={`qt2-status ${item.statusClass}`}>
                        ● {item.status}
                      </div>

                      <div className="qt2-actions">
                        <button
                          className="cancel-btn"
                          style={{ width: "3rem", fontSize: "9px" }}
                        >
                          View
                        </button>

                        <button
                          className="cancel-btn"
                          style={{ width: "3rem", fontSize: "9px" }}
                        >
                          Resend
                        </button>
                      </div>
                    </div>
                  </div>
                ))}

                <div className="qt3-active-bar">
                  <div className="qt3-left">
                    <div className="qt3-label">LATEST ACTIVE QUOTATION</div>

                    <div className="qt3-title">QT–2026–041 · ₹12,40,000</div>
                  </div>

                  <div className="qt3-actions">
                    <button className="qt3-download">Download PDF</button>

                    <button className="qt3-accept">Mark as Accepted</button>
                  </div>
                </div>
              </>
            )}

            {tab === "conversations" && (
              <>
                <div className="conversation-header">
                  <div className="filters my-2">
                    <button
                      className={filterTab === "All" ? "active" : "cancel-btn"}
                      style={{ width: "5rem", fontSize: "10px" }}
                      onClick={() => setFilterTab("All")}
                    >
                      All
                    </button>

                    <button
                      className={
                        filterTab === "Email" ? "active" : "cancel-btn"
                      }
                      style={{ width: "5rem", fontSize: "10px" }}
                      onClick={() => setFilterTab("Email")}
                    >
                      Email
                    </button>

                    <button
                      className={filterTab === "Call" ? "active" : "cancel-btn"}
                      style={{ width: "5rem", fontSize: "10px" }}
                      onClick={() => setFilterTab("Call")}
                    >
                      Call
                    </button>

                    <button
                      className={filterTab === "Note" ? "active" : "cancel-btn"}
                      style={{ width: "5rem", fontSize: "10px" }}
                      onClick={() => setFilterTab("Note")}
                    >
                      Note
                    </button>
                  </div>

                  <button
                    className="submit-btn"
                    onClick={() => setShowLogActivity(!showLogActivity)}
                  >
                    + Log Activity
                  </button>
                </div>

                {showLogActivity && (
                  <Card
                    style={{
                      marginTop: "16px",
                      borderRadius: "14px",
                      border: "1px solid #e5e7eb",
                      padding: "10px",
                    }}
                    className="my-2"
                  >
                    <div
                      style={{
                        fontWeight: "600",
                        fontSize: "16px",
                        marginBottom: "12px",
                      }}
                    >
                      Add Note / Log Activity
                    </div>

                    <Form.Group>
                      <Form.Control
                        as="textarea"
                        rows={4}
                        placeholder="Add a note or summary about this interaction..."
                        value={note}
                        onChange={(e) => setNote(e.target.value)}
                        style={{ borderRadius: "10px", fontSize: "14px" }}
                      />
                    </Form.Group>

                    <div
                      style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        gap: "10px",
                        marginTop: "16px",
                        flexWrap: "wrap",
                      }}
                    >
                      <button
                        variant="light"
                        onClick={() => {
                          setShowLogActivity(false);
                          setNote("");
                        }}
                        style={{
                          width: "5rem",
                        }}
                        className="cancel-btn"
                      >
                        Cancel
                      </button>

                      <button
                        style={{
                          width: "5rem",
                        }}
                        className="submit-btn"
                      >
                        Save
                      </button>
                    </div>
                  </Card>
                )}

                <Accordion className="cv-accordion">
                  {conversations.map((item, index) => (
                    <Accordion.Item
                      eventKey={index.toString()}
                      key={index}
                      className="cv-card"
                    >
                      <Accordion.Header>
                        <div className="cv-row">
                          <div className={`cv-icon ${item.color}`}>
                            {item.icon}
                          </div>

                          <div className="cv-content">
                            <div className="cv-title-row">
                              <div className="cv-title">{item.title}</div>

                              <span className={`cv-tag cv-${item.color}`}>
                                {item.tag}
                              </span>
                            </div>

                            <div className="cv-meta">
                              {item.user} · {item.time}
                            </div>

                            <div className="cv-preview">{item.preview}</div>
                          </div>
                        </div>
                      </Accordion.Header>

                      <Accordion.Body>
                        <div className="cv-details-text">{item.details}</div>

                        <div className="cv-actions">
                          <button
                            className="cv-btn-light  cancel-btn"
                            style={{ width: "5rem", fontSize: "10px" }}
                          >
                            Reply
                          </button>

                          <button
                            className="cv-btn-light cancel-btn"
                            style={{ width: "5rem", fontSize: "10px" }}
                          >
                            Forward
                          </button>

                          <button
                            className="cv-btn-light cancel-btn"
                            style={{ width: "5rem", fontSize: "10px" }}
                          >
                            Link to Quote
                          </button>
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>
                  ))}
                </Accordion>
              </>
            )}
          </Col>
        </Row>
      </Container>
    </>
  );
}
